import React from 'react';
import { FlatList, FlatListProps } from 'react-native';

export interface AppListViewProps<T> extends FlatListProps<T> {
  data: T[];
}
function BaseAppListView(props: AppListViewProps<any>) {
  return <FlatList {...props} />;
}

export const AppListView = React.memo(BaseAppListView);
/*

function BaseAppListView(props: Props<any>) {
  const scrollY = useRef(new Animated.Value(0)).current;
  const [contentHeight, setContentHeight] = useState(0);
  const [containerHeight, setContainerHeight] = useState(0);
  return (
    <>
      <FlatList
        onLayout={(e) => setContainerHeight(e.nativeEvent.layout.height)}
        onContentSizeChange={(w, h) => setContentHeight(h)}
        onScroll={Animated.event([{ nativeEvent: { contentOffset: { y: scrollY } } }], { useNativeDriver: false })}
        {...props}
      />
      <ScrollIndicator inverted={props.inverted || false} scrollY={scrollY} contentHeight={contentHeight} containerHeight={containerHeight} />
    </>
  );
}

const ScrollIndicator = ({ scrollY, contentHeight, containerHeight, inverted }) => {
  const indicatorHeight = containerHeight * (containerHeight / contentHeight);

  const translateY = scrollY.interpolate({
    inputRange: inverted ? [0, Math.max(0, contentHeight - containerHeight)] : [0, Math.max(0, contentHeight - containerHeight)],
    outputRange: inverted ? [Math.max(0, containerHeight - indicatorHeight), 0] : [0, Math.max(0, containerHeight - indicatorHeight)],
    extrapolate: 'clamp',
  });

  return (
    <Animated.View
      style={[
        styles.indicator,
        {
          height: indicatorHeight,
          transform: [{ translateY }],
        },
      ]}
    />
  );
};

const styles = StyleSheet.create({
  indicator: {
    width: 10,
    backgroundColor: 'blue',
    borderRadius: 5,
    position: 'absolute',
    right: 0,
  },
});
*/
